/**
 * Enveloppe de toutes les pages de la caisse (posée par VendorProtectedRoute).
 *
 * 1. Plancher tactile (21/10/2026) : la classe `caisse-tactile` sur <html> donne
 *    à toute cible au moins 48 px de côté et 16 px de texte (index.css). Posée sur
 *    <html> pour atteindre aussi les fenêtres rendues hors de la page ; retirée en
 *    partant vers le tableau de bord.
 *
 * 2. Clavier à l'écran : UN seul, pour toutes les pages de la caisse. Il n'était
 *    monté que sur la vente et sur Stocks : Réappro, Réception, Précommandes…
 *    n'avaient aucun moyen de taper sans clavier physique, alors qu'il n'y en a
 *    pas sur les postes en journée. Clavier AZERTY maison : conçu pour un écran
 *    TACTILE SANS clavier natif (Mac mini + moniteur tactile — macOS n'offre aucun
 *    clavier à l'écran pour un champ web). Il mesure 1200 × 680 px : sur un iPhone
 *    il déborde de partout et se superpose au clavier iOS (signalé le 09/08/2026).
 *    iOS et iPadOS fournissent DÉJÀ leur clavier — on leur laisse la main.
 */
import { useEffect, type ReactNode } from 'react';
import { useTenant } from '../../contexts/TenantContext';
import { VirtualKeyboardProvider } from '../../contexts/VirtualKeyboardContext';
import { IS_TOUCH_DEVICE } from '../../utils/touchDevice';
import VirtualKeyboard from './VirtualKeyboard';

export default function CaisseTactile({ children }: { children: ReactNode }) {
  const { tenant } = useTenant();

  useEffect(() => {
    document.documentElement.classList.add('caisse-tactile');
    return () => document.documentElement.classList.remove('caisse-tactile');
  }, []);

  const clavier = (tenant?.pos_virtual_keyboard_enabled ?? false) && !IS_TOUCH_DEVICE;

  return (
    <VirtualKeyboardProvider enabled={clavier}>
      {children}
      <VirtualKeyboard />
    </VirtualKeyboardProvider>
  );
}
